(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STYLE_ID = 'kmb-contact-forms-style';
    const CSS = `
      :host {
        --container-text-alignment: left;
        --forms-heading-font: normal 500 22px Space Grotesk, sans-serif;
      }

      section[data-sizing="form-wrapper"] {
        text-align: left;
        justify-self: baseline;
        max-width: 76rem !important;
        width: 100%;
        margin: 0 auto;
        margin-top: 1rem;
        margin-bottom: 4rem;
        padding-right: 5rem;
        box-sizing: border-box;
        > * {
          max-width: 60rem;
        }
      }

      @media (min-width: 1024px) {
        section[data-sizing="form-wrapper"] {
          margin-top: 3.5rem;
          padding-right: 10rem;
        }
      }

      form {
        position: relative;
        div:nth-child(3):before {
          background: transparent;
        }
      }

      div[class*="_formFieldContainer"] {
        margin-bottom: 1.5rem;
      }

      div[class*="_textBody"] {
        font-size: 1.375rem;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 2.5rem !important;
      }

      @media (min-width: 1024px) {
        div[class*="_textBody"] {
          font-size: 2.1875rem;
          line-height: 1;
          margin-bottom: 4.5rem !important;
          text-wrap: pretty;
        }
      }

      input[type="text"],
      input[type="email"],
      textarea {
        background: none;
        border: 0;
        padding: 1.3rem 0 0rem 0;
        box-shadow: none;
        border-radius: 0;
        border-bottom: 1px solid #A06127;
        font-size: 1rem;
        font-weight: 500;
        color: #A06127 !important;
        &:focus {
          outline: 0 !important;
          box-shadow: none;
          border-bottom: 1px solid #A06127;
        }
      }

      textarea[name="custom#message"] {
        padding: 1.5rem 0 0rem 0 !important;
        background: transparent;
        box-shadow: none;
        border: 0;
        border-bottom: 1px solid #A06127;
        border-radius: 0;
        field-sizing: content;
      }

      label {
        text-transform: uppercase;
        color: #A06127 !important;
        font-size: 1rem !important;
        font-weight: 500 !important;
        letter-spacing: 1px;
        left: 0px !important;
        opacity: 0.75;
      }

      button[type="submit"] {
        background: none;
        border: 1px solid #A06127;
        color: #A06127;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 500;
        padding: 0.75rem 1.75rem;
        border-radius: 2rem;
        font-size: 1rem;
        line-height: 21px;
        padding: 4px 10px 4px 14px;
        width: fit-content;
        &:hover {
          border: 1px solid #A06127 !important;
          background: #A06127;
          color: #F9F2EA;
        }
      }
      div[class*="_formFieldContainer"]::before {
        display: none;
      }
    `;

    const supportsAdopted =
      typeof CSSStyleSheet !== 'undefined' &&
      'adoptedStyleSheets' in Document.prototype &&
      typeof CSSStyleSheet.prototype.replaceSync === 'function';

    const inject = (root) => {
      if (!root) return;

      if (supportsAdopted) {
        if (root.__kmbContactFormsStyleSheet) return;
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
        root.__kmbContactFormsStyleSheet = sheet;
        return;
      }

      if (root.querySelector(`#${STYLE_ID}`)) return;
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    };

    const tryInject = () => {
      const host = document.querySelector('[data-forms-id="forms-root-852605"] shopify-forms-embed');
      if (!host) return false;
      const root = host.shadowRoot;
      if (!root) {
        console.warn('[forms] Shadow root not accessible (closed). Direct styling not possible.');
        return false;
      }

      inject(root);

      if (!root.__kmbContactFormsObserver) {
        const observer = new MutationObserver(() => inject(root));
        observer.observe(root, { childList: true, subtree: true });
        root.__kmbContactFormsObserver = observer;
      }

      console.log('[forms] Contact shadow styles injected');
      return true;
    };

    if (tryInject()) return;

    const watcher = new MutationObserver(() => {
      if (tryInject()) watcher.disconnect();
    });
    watcher.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nwltr-before"]) return;
  try {
    
  (() => {
    const STYLE_ID = 'kmb-forms-style';
    const CSS = `
      :host {
        --container-text-alignment: left;
        --forms-heading-font: normal 500 22px Space Grotesk, sans-serif;
      }

      section[data-sizing="form-wrapper"] {
        max-width: 37.5rem !important;
        width: 100%;
        padding: 0 2rem;
        text-align: left;
      }

      section[data-sizing="form-wrapper"] h2 {
        font-size: 1.375rem;
        line-height: 1.2875em;
        margin-bottom: 4rem;
      }

      div[class*="_formDisclaimer"] {
        display: none;
      }

      @media (min-width: 1024px) {
        section[data-sizing="form-wrapper"] h2 {
          font-size: 2.1875rem;
          line-height: 2.75rem;
          margin-bottom: 5rem;
        }
      }

      form {
        position: relative;
      }

      input#email {
        background: none;
        border: 0;
        padding: 1rem 0 0rem 0;
        box-shadow: none;
        border-radius: 0;
        border-bottom: 1px solid #A06127;
        font-size: 1rem;
        font-weight: 500;
        color: #A06127;
      }

      input#email:focus + label#label-email,
      input#email:not(:placeholder-shown) + label#label-email {
        opacity: 0;
      }

      label#label-email {
        text-transform: uppercase;
        color: #A06127;
        font-size: 1rem;
        font-weight: 500;
        letter-spacing: 1px;
        left: 0px;
        top: 17.5px !important;
        opacity: 0.75;
      }

      button[type="submit"] {
        background: none;
        text-indent: 150%;
        white-space: nowrap;
        background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMS4yOTYiIGhlaWdodD0iOC40OTUiIHZpZXdCb3g9IjAgMCAxMS4yOTYgOC40OTUiPgogIDxwYXRoIGlkPSJQYXRoXzExMzkiIGRhdGEtbmFtZT0iUGF0aCAxMTM5IiBkPSJNOC4zODQuMTQ0LDcuMzI4LS45LDkuMjgtMi44MzJsLjU5Mi0uMzg0LS4wOC0uMjQtLjcuMTEySC44di0xLjVIOS4wODhsLjcuMTEyLjA4LS4yNEw5LjI4LTUuMzYsNy4zMjgtNy4zLDguMzg0LTguMzUyLDEyLjEtNC42NHYxLjA4OFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjggOC4zNTIpIiBmaWxsPSIjYTA2MTI3Ii8+Cjwvc3ZnPg==");
        background-repeat: no-repeat;
        background-position: center center;
        width: 28px;
        height: 28px;
        overflow: hidden;
        margin: 0;
        padding: 0;
        position: absolute;
        top: 12px;
        right: -5px;
      }
      shop-lead-capture {
      display: none
      }
    `;

    const supportsAdopted =
      typeof CSSStyleSheet !== 'undefined' &&
      'adoptedStyleSheets' in Document.prototype &&
      typeof CSSStyleSheet.prototype.replaceSync === 'function';

    const inject = (root) => {
      if (!root) return;

      if (supportsAdopted) {
        if (root.__kmbFormsStyleSheet) return;
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS);
        root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
        root.__kmbFormsStyleSheet = sheet;
        return;
      }

      if (root.querySelector(`#${STYLE_ID}`)) return;
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    };

    const tryInject = () => {
      const host = document.querySelector('shopify-forms-embed');
      if (!host) return false;
      const root = host.shadowRoot;
      if (!root) {
        console.warn('[forms] Shadow root not accessible (closed). Direct styling not possible.');
        return false;
      }

      inject(root);

      if (!root.__kmbFormsObserver) {
        const observer = new MutationObserver(() => inject(root));
        observer.observe(root, { childList: true, subtree: true });
        root.__kmbFormsObserver = observer;
      }

      console.log('[forms] Shadow styles injected');
      return true;
    };

    if (tryInject()) return;

    const watcher = new MutationObserver(() => {
      if (tryInject()) watcher.disconnect();
    });
    watcher.observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const bindVariantImageSwap = (form) => {
      if (!form || form.dataset.variantImageBound === 'true') return;

      const mainImage = document.querySelector('[data-product-main-image]');
      if (!mainImage) return;

      const nextImage = document.querySelector('[data-product-next-image]');
      let transitionId = 0;
      let transitionTimer = null;

      form.dataset.variantImageBound = 'true';
      mainImage.dataset.currentImageSrc = mainImage.getAttribute('src') || mainImage.src;

      const applyImage = (image, input, updateAlt = true) => {
        if (!input?.dataset?.imageSrc) return;

        image.src = input.dataset.imageSrc;

        if (input.dataset.imageSrcset) {
          image.srcset = input.dataset.imageSrcset;
        }

        if (updateAlt && input.dataset.imageAlt) {
          image.alt = input.dataset.imageAlt;
        }
      };

      const updateImage = (input) => {
        if (!input?.dataset?.imageSrc) return;
        if (mainImage.dataset.currentImageSrc === input.dataset.imageSrc) return;

        if (!nextImage) {
          applyImage(mainImage, input);
          mainImage.dataset.currentImageSrc = input.dataset.imageSrc;
          return;
        }

        transitionId += 1;
        const currentTransitionId = transitionId;

        if (transitionTimer) {
          window.clearTimeout(transitionTimer);
        }

        const finish = () => {
          if (currentTransitionId !== transitionId) return;

          applyImage(mainImage, input);
          mainImage.dataset.currentImageSrc = input.dataset.imageSrc;
          nextImage.classList.remove('is-visible');
        };

        const startFade = () => {
          if (currentTransitionId !== transitionId) return;

          nextImage.classList.remove('is-visible');
          applyImage(nextImage, input, false);
          nextImage.offsetWidth;
          nextImage.classList.add('is-visible');
          transitionTimer = window.setTimeout(finish, 260);
        };

        const preloader = new Image();
        preloader.sizes = mainImage.sizes;
        if (input.dataset.imageSrcset) {
          preloader.srcset = input.dataset.imageSrcset;
        }
        preloader.onload = startFade;
        preloader.onerror = startFade;
        preloader.src = input.dataset.imageSrc;
      };

      form.querySelectorAll('input[name="id"][data-image-src]').forEach((input) => {
        input.addEventListener('change', () => updateImage(input));
      });

      updateImage(form.querySelector('input[name="id"][data-image-src]:checked'));
    };

    const initVariantImageSwaps = () => {
      document.querySelectorAll('form.product-form').forEach(bindVariantImageSwap);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initVariantImageSwaps);
    } else {
      initVariantImageSwaps();
    }

    document.addEventListener('shopify:section:load', initVariantImageSwaps);
  })();

  } catch(e) { console.error(e); }
})();
})();
